<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      :class="$style.card"
      mobile-negative-margin
    >
      <template #head>
        <div :class="$style.head">
          <lv-heading
            level="2"
            tag="h2"
            version2
          >
            {{ $awt('aw.pages.inspiration.title') }}
          </lv-heading>
          <aw-simple-search-input
            v-model:search-text="searchText"
            :placeholder="$awt('aw.pages.inspiration.search.placeholder')"
            :class="$style.headSearch"
            @search="changeKeyword"
            @clear="clearSearch"
          />
        </div>
      </template>
      <aw-aggregated-page-highlighted-carousel page-type="inspiration" />
      <aw-aggregated-page-tabs :key="keyword ?? undefined" :params="{ title: keyword}" page-type="inspiration" />
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { onMounted, provide, ref } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwSimpleSearchInput from '~~/common/components/Common/AwSimpleSearchInput.vue';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwAggregatedPageTabs from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageTabs.vue';
  import AwAggregatedPageHighlightedCarousel from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageHighlightedCarousel.vue';
  import { defineI18nRoute } from '#i18n';

  defineOptions({
    name: 'InspirationsPage',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });
  const { $awt } = useNuxtApp();
  provide('getRowIndexById', () => 0);
  const keyword = ref<string | null>(null);
  const searchText = ref('');

  const changeKeyword = (newKeyword: string) => {
    keyword.value = newKeyword;
  };

  const clearSearch = () => {
    keyword.value = '';
  };

  onMounted(() => {
    const breadcrumbStore = useBreadcrumbStore();

    breadcrumbStore.setBreadcrumbs([
      {
        token: $awt('aw.common.category.home'),
        to: '/',
        disabled: false,
      },
      {
        token: $awt('aw.pages.inspiration.title'),
        to: 'inspirations',
        disabled: true,
      },
    ]);
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/inspirations',
      hu: '/inspiraciok',
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.head {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @include tablet(min) {
    flex-direction: row;
    justify-content: space-between;
  }

  &Search {
    width: 100%;
    @include tablet(min) {
      max-width: 520px;
    }
  }
}

.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}
</style>
